<template>
    <v-checkbox
        color="red"
        :hideDetails="hideDetails"
        @update:modelValue="checkboxChange"
        v-model="isChecked"
        :label="label"
    ></v-checkbox>
</template>

<script>
    export default {
        name: 'sm-checkbox',
        props: {
            modelValue: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: 'Select',
            },
            required: {
                type: Boolean,
                default: true,
            },
            hideDetails: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isChecked: false,
            }
        },
        mounted() {
            this.isChecked = this.modelValue
        },
        methods: {
            checkboxChange(newValue) {
                this.isChecked = newValue
                this.$emit('update:modelValue', newValue)
            },
        },
    }
</script>
